<template>
  <div class="page">
    <van-loading color="#00bb5a" size="32">加载中...</van-loading>
  </div>
</template>
<script>
import { Toast } from 'vant'
let tt
export default {
  data () {
    return {

    }
  },
  computed: {
    uid () {
      return this.$route.query.id || ''
    }
  },
  async created () {
    if (this.uid) {
      await this.$axios.post('auth/grouponUrl', {
        uid: this.uid
      }).then(response => {
        console.log(response)
        if (response.data.code === 200) {
          const res = response.data.data || {}
          if (res.url) {
            window.location.href = res.url
          } else {
            Toast('获取不到连接，无法跳转')
          }
        } else {
          Toast(response.data.message || '跳转失败')
        }
      }).catch((e) => {
        console.log(e)
      })
      Toast.clear()
    }
  },

  methods: {

  }
}
</script>
<style lang="less" scoped>
  .page {
    min-height: 100vh;
    background: #ffffff;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
